import Vue from "vue";
import Vuex from "vuex";
import lastGreeting from "../api/lastGreeting";

Vue.use(Vuex);

const initialState = {
  lastGreetings: [],
  lastGreetingsLoading: false
};

const getters = {
  lastGreetings(state) {
    return state.lastGreetings;
  },
  lastGreetingsLoading(state) {
    return state.lastGreetingsLoading;
  },
  // myEmailNotifications(state) {
  //   return state.myEmailNotifications
  // },
};

export const actions = {
  async getLastGreetings(context, payload) {
    try {
      context.state.lastGreetingsLoading = true;
      const response = await lastGreeting.getLastGreetings(payload);
      context.state.lastGreetings = response.data.lastGreetings;
      context.state.lastGreetingsLoading = false;
      return Promise.resolve();
    } catch (error) {
      context.state.lastGreetingsLoading = false;
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async addLastGreeting(context, payload) {
    try {
      const response = await lastGreeting.addLastGreeting(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.addLastGreeting,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async editLastGreeting(context, payload) {
    try {
      const response = await lastGreeting.editLastGreeting(payload);
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.success.editLastGreeting,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async deleteLastGreeting(context, payload) {
    try {
      const response = await lastGreeting.deleteLastGreeting(payload);
      context.commit(
        "toast",
        {
          message:
            context.rootState.langObj.response.success.deleteLastGreeting,
          color: "black",
        },
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
